
import { computed, defineComponent, onBeforeMount, ref } from 'vue';

import { useRoute } from 'vue-router';

import { routes } from '@/router/index';

export default defineComponent({
  setup() {
    const route = useRoute();

    const selectedKeys = ref<string[]>([String(route?.name)]);
    const openKeys = ref<string[]>([]);
    const tabMenu = routes;

    const getTabMenu = computed(() => {
      return tabMenu.filter((obj) => !!obj.label);
    });

    onBeforeMount(() => {
      const ownTab = tabMenu.find((obj) =>
        obj.children?.some((obj) => obj.name === route.name)
      );
      openKeys.value = [ownTab?.label || ''];
    });

    return {
      // state
      selectedKeys,
      openKeys,
      collapsed: ref<boolean>(false),
      tabMenu,
      // func
      // computed
      getTabMenu,
    };
  },
});
